/**
 * CloudWatch RUM opcional (trazit-tracking #186).
 * Solo arranca si config.cloudWatchRum.enabled === true y hay appMonitorId + identityPoolId.
 * No usar en clientes (TCM, etc.) sin acuerdo. Demo TRAZiT únicamente en el VAL.
 */

const CWR_VERSION = '1.19.0';

export function initCloudWatchRum(config) {
  const rum = config && config.cloudWatchRum;
  if (!rum || rum.enabled !== true) return;
  if (typeof window === 'undefined' || window.__trazitCwRumStarted) return;

  const appMonitorId = String(rum.appMonitorId || '').trim();
  const identityPoolId = String(rum.identityPoolId || '').trim();
  const region = String(rum.region || 'eu-west-3').trim();
  if (!appMonitorId) {
    console.warn('[rum] cloudWatchRum.enabled pero falta appMonitorId');
    return;
  }

  window.__trazitCwRumStarted = true;

  // El bundle JS solo vive en el CDN us-east-1. La región del monitor va en
  // el 4º arg del snippet y en endpoint (dataplane.rum.<region>).
  const loader = `https://client.rum.us-east-1.amazonaws.com/${CWR_VERSION}/cwr.js`;
  const telemetries = Array.isArray(rum.telemetries) && rum.telemetries.length
    ? rum.telemetries
    : ['performance', 'errors'];

  const clientConfig = {
    sessionSampleRate: rum.sessionSampleRate != null ? Number(rum.sessionSampleRate) : 1,
    endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
    telemetries,
    allowCookies: rum.allowCookies === true,
    enableXRay: false,
    signing: Boolean(identityPoolId),
  };
  if (identityPoolId) clientConfig.identityPoolId = identityPoolId;
  if (rum.guestRoleArn) clientConfig.guestRoleArn = String(rum.guestRoleArn).trim();

  /* eslint-disable */
  (function (n, i, v, r, s, c, x, z) {
    x = window.AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
    window[n] = function (c, p) { x.q.push({ c: c, p: p }); };
    z = document.createElement('script');
    z.async = true;
    z.src = s;
    document.head.insertBefore(z, document.head.getElementsByTagName('script')[0]);
  })(
    'cwr',
    appMonitorId,
    '1.0.0',
    region,
    loader,
    clientConfig
  );
  /* eslint-enable */
}
